import { Component, Output, Input, EventEmitter, OnInit, OnDestroy, ViewEncapsulation, ViewChild } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import {Listbox, ListboxModule} from "primeng/listbox";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TooltipModule} from "primeng/tooltip";
import {NgClass} from "@angular/common";
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { BskselectComponent } from '@documalis/bskselect/bskselect.component';

@Component({
    standalone: true,
    selector: 'app-form-screenbsk',
    imports: [ReactiveFormsModule,
        ListboxModule,
        TranslateModule,
        TooltipModule,
        NgClass, 
        TableModule,
        InputTextModule,
        BskselectComponent
    ],  
    templateUrl: './form-screenbsk.component.html',
    styleUrls: ['./form-screenbsk.component.scss'],
    providers: [AutofocusDirective],
    encapsulation: ViewEncapsulation.None
})
export class FormScreenBskComponent extends FormBase implements OnInit, OnDestroy {
    public requestForm: FormGroup;
    public currentList = [];
    public validClick = false;
    public isAdmin = false;
    public readOnly = false;    

    @Input()
    public request: any = null;

    @Input()
    public tagList = [];

    @Input()
    public basketList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    @ViewChild('bskList') public bskList: Listbox;
    @ViewChild('bskselect') public bskselect: BskselectComponent;

    public listColumns = [];

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.requestForm = this.formBuilder.group({
            id: null,
            tagList: [null, [Validators.required]],
            basketList: [null, [Validators.required]],
        });
        this.initialization();
    }

    ngOnInit() {
        if (this.request !== null) {
            this.request.notifyParent.subscribe(success => {
                this.requestForm.patchValue(this.request);
                this.bskselect.updateSelectedRows(this.request.basketList);
                this.readOnly = true;
            })
        }
        this.listColumns = [{header: '', field: 'Label', type: 'String', sort: null}];
    }

    ngOnDestroy() {
        if (this.request !== null) {            
            this.request.notifyParent.unsubscribe()
        }
    }
        
    public validate() {
        this.validClick = true;
        const error: Array<Message> = [];
        this.requestForm.controls['basketList'].patchValue(this.bskselect.getBasketList());
        if (this.requestForm.invalid) {
            this.getErrorsInputs(error, this.requestForm);
        } else {
            this.onValidate.emit(this.requestForm.value);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.request);
    }

    public clickcolck(event) {
        event.stopPropagation();
    }

    public clickcolReqck(event) {
        event.stopPropagation();
    }

    private initialization() {
        this.keys = {
            tagList: {
                label: this.translate.instant('Screen'),
                pattern: '',
            },
            basketList: {
                label: this.translate.instant('Basket'),
                pattern: '',
            },
        };
    }
}
